@import 'bootstrap/dist/css/bootstrap.min.css';
@import '@formio/js/dist/formio.full.min.css';

.app {
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: Roboto, 'Helvetica Neue', Helvetica, arial, sans-serif;
  color: #58595b;
  display: flex;
  flex-flow: row wrap;
  text-align: center;
  min-height: 100vh;
}

.app > * {
  flex: 1 100%;
  flex-shrink: 0;
}

.main {
  flex-grow: 1;
  height: calc(100vh - 114px);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  text-align: center;
  color: #888888;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;
}

.error {
  flex-direction: column;
  flex: 1 100vw;
  align-self: center;
  width: 100vw;
}

.no-forms {
  flex-direction: column;
  margin: 6px;
  flex: 1 100%;
  align-self: center;
}

.no-forms > * {
  margin: 0 0 6px 0;
}

.circle-icon,
.error-icon,
.no-forms .edit-icon {
  width: 48px;
  height: 48px;
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1), 0px 4px 55px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  margin: auto;
  align-items: center;
  margin-bottom: 16px;
}

.circle-icon,
.error-icon svg,
.no-forms .edit-icon svg {
  height: 48px;
  color: #2e72f6;
}

.main .primary {
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: #000;
}

.header {
  height: 49px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #eff1f4;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px 6px 0px 0px;
  padding-right: 15px;
  padding-left: 15px;
}

.header .header-row {
  display: flex;
}

.header .back-button {
  margin: 0 8px 0 0;
}

.header .circle-icon {
  height: 22px;
  width: 22px;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.header .circle-icon svg {
  height: 0.75em;
  width: 0.75em;
}

.header .title {
  height: 19px;
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.header .btn-group {
  display: flex;
  margin: 0 0 0 5px;
  align-items: center;
  height: 30px;
}

.header input {
  margin-right: 5px;
}

.button-bar {
  align-content: flex-start;
}

.button-bar Button {
  margin-right: 16px;
}

.tooltray-right {
  margin-right: 3em;
}

.form-title {
  padding: 0 5px 0 15px;
  display: flex;
  align-items: center;
}

.form-title-view {
  padding-right: 0;
}

.icon {
  display: flex;
  align-items: center;
  padding: 0 5px;
  cursor: pointer;
  font-size: 1.25em;
}

.icon:hover {
  color: #5871a2;
  transform: scale(1.35);
  -webkit-transform: scale(1.35);
  -moz-transform: scale(1.35);
}

.dot {
  display: flex;
  align-items: center;
  font-size: 6px;
  color: #777777;
  padding: 0 8px;
}

.form-type {
  padding: 0 5px;
  display: flex;
  align-items: center;
  color: #777777;
}

.form-type.viewer {
  padding-left: 0;
}

.footer {
  height: 65px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);
  border-radius: 0px 0px 6px 6px;
}

.btn-group {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  padding: 0px;
  height: 35px;
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: 10px 0px;
}

.btn-group button {
  background: #fff;
  border: 1px solid #d5e3fd;
  box-sizing: border-box;
  border-radius: 6px !important;
  color: #2e72f6;
}

.btn-group > * {
  margin-right: 10px;
}

.btn-group > *:last-child {
  margin-right: 0;
}

.btn-group button.btn-primary {
  background: #2e72f6;
  color: #fff;
}
.btn-group button.btn-secondary {
  background: #fff;
}

.form-builder-container {
  overflow: auto;
  padding: 0;
  height: calc(100vh - 114px);
}

.form-builder-container .row {
  margin: 0;
  height: 100%;
}

.form-builder-container .row .formcomponents {
  padding-left: 0;
}

.form-builder {
  margin-right: -15px;
  text-align: left;
}

.form-viewer-container {
  padding: 15px 15px;
  text-align: left;
  min-width: 500px;
}

.form-viewer-container.preview {
  padding-top: 0px;
}

.panel-title {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 13px 15px;
  margin: 0 -15px;
  height: 45px;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  background: #ffffff;
  box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.08);
}

.left-border {
  border-left: 1px solid rgba(0, 0, 0, 0.08);
}

/** Create New **/
.create-new p {
  margin-top: 1em;
}
.create-new #createTitle {
  min-width: 200px;
}

.create-new .select {
  min-width: 200px;
}

.create-new .MuiFormControl-root {
  margin: 0 0 0 20px;
}

.create-new .MuiFormControl-root:first-of-type {
  margin: 0 0 0 0;
}

/** Form.io Overrides **/
.builder-sidebar_search {
  display: none;
}

.formcomponents {
  min-width: 25%;
}

.formarea {
  max-width: 75%;
}

/** PRINT **/
@media screen {
  .print {
    display: none !important;
  }
}

@media print {
  @page {
    margin: 15px;
  }

  .no-print {
    display: none !important;
  }

  .print {
    display: block;
  }
}


/** FormEditor **/
.half-width {
  padding: 0 16px;
}